'use client';

import { useI18n } from '~/features/i18n';
import type { SpecificRFC } from '~/utils/react';
import { VATKindDisplay } from '../portals/money';

type I18nFC<Props extends Record<string, unknown>> = SpecificRFC<Props, string>;

export const I18n_AmountPerParticipant: I18nFC<{
    /** The amount per participant. */
    amount: string | number | ((i18n: ReturnType<typeof useI18n>) => string);
    /**  Wether or not to disable the `'€'` sign prefix rendered the `amount`
     *
     * @default false */
    disableEURPrefix?: boolean;

    /** @default false */
    abbreviated?: boolean;
}> = props => {
    const i18n = useI18n();

    const amount = `${props.disableEURPrefix === true ? '' : '€'}${
        typeof props.amount === 'function' ? props.amount(i18n) : props.amount
    }`;

    return props.abbreviated
        ? `${amount} ${i18n._('p.p.')}`
        : `${amount} ${i18n._('p.p.')} ${VATKindDisplay({})}`;
};
